import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: ":datasetId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "dataset-details" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
